import React from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import WorkoutHeader from "../components/WorkoutHeader";
import { useWorkout } from "../hooks/workoutHook";
import { useParams } from "react-router-dom";
import ContainerResponsive from "../../common/components/ContainerResponsive";
import DetailCol from "../../common/components/DetailCol";
import DetailsHeader from "../../common/components/DetailsHeader";
import { useWindowWidth } from "../../api/useWindowWidth";

export default function WorkoutExerciseDetails() {
  const workoutContext = useWorkout();
  const [_, isMobile] = useWindowWidth();
  const { idSuperserie, idExercise } = useParams();
  const workout = workoutContext.workoutData.workout;
  const exercise = workout.superseries[idSuperserie].exercises[idExercise];
  return (
    <div
      style={{
        minHeight: "100vh",
      }}
    >
      {isMobile ? <DetailsHeader /> : <WorkoutHeader title={exercise.name} showCompleted={false} showLogo={true} />}
      {isMobile ? (
        <div>
          <Row className="m-auto text-center">
            <Col
              lg={6}
              className="m-auto px-0"
              style={{
                backgroundImage: `url(${exercise.cover})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                aspectRatio: 1,
                maxHeight: "60vh"
              }}
            />
            <Col lg={6} className="py-3">
              <Row className="text-start pb-2">
                <p className="mb-0" style={{ fontWeight: "bold", fontSize: 24 }}>{exercise.name}</p>
                <p className="mb-0">{exercise.description}</p>
              </Row>
              <Row className="m-auto">
                {exercise.weight > 0 && (
                  <DetailCol
                    paddingRight={true}
                    mainText={exercise.weight + " kg"}
                    secondaryText={"Peso"}
                    my={true}
                  />
                )}
                {exercise.repetitions > 0 && (
                  <DetailCol
                    paddingLeft={exercise.weight > 0}
                    paddingRight={exercise.duration > 0 || exercise.rest > 0}
                    mainText={`${exercise.repetitions}${exercise.both_sides ? " per lato" : ""
                      }`}
                    secondaryText={"Ripetizioni"}
                    my={true}
                  />
                )}
                {exercise.duration > 0 && (
                  <DetailCol
                    paddingLeft={
                      exercise.weight > 0 || exercise.repetitions > 0
                    }
                    paddingRight={
                      !(exercise.weight > 0 || exercise.repetitions > 0)
                    }
                    mainText={`${exercise.duration}${exercise.both_sides ? "'' per lato" : "''"
                      }`}
                    secondaryText={"Isometria"}
                    my={true}
                  />
                )}
                {exercise.centimeters > 0 && (
                  <DetailCol
                    paddingLeft={true}
                    mainText={exercise.centimeters}
                    secondaryText={"Centimetri"}
                    my={true}
                  />
                )}
                {exercise.rest > 0 && (
                  <DetailCol
                    paddingLeft={true}
                    mainText={exercise.rest + "''"}
                    secondaryText={"Riposo"}
                    my={true}
                  />
                )}
              </Row>
            </Col>
          </Row>
        </div>
      ) : (
        <ContainerResponsive>
          <Container className="mt-2">
            <Row className="m-auto text-center">
              <Col lg={6} className="m-auto px-0">
                <img
                  src={exercise.cover}
                  style={{ maxWidth: "100%", maxHeight: "60vh" }}
                  className="rounded-md shadow"
                  alt={exercise.name}
                />
              </Col>
              <Col lg={6} className="py-2">
                <Row className="text-start pb-2">
                  <p className="mb-0" style={{ fontWeight: "bold", fontSize: 24 }}>{exercise.name}</p>
                  <p className="mb-0">{exercise.description}</p>
                </Row>
                <Row className="m-auto">
                  {exercise.weight > 0 && (
                    <DetailCol
                      paddingRight={true}
                      mainText={exercise.weight + " kg"}
                      secondaryText={"Peso"}
                      my={true}
                    />
                  )}
                  {exercise.repetitions > 0 && (
                    <DetailCol
                      paddingLeft={exercise.weight > 0}
                      paddingRight={exercise.duration > 0 || exercise.rest > 0}
                      mainText={`${exercise.repetitions}${exercise.both_sides ? " per lato" : ""
                        }`}
                      secondaryText={"Ripetizioni"}
                      my={true}
                    />
                  )}
                  {exercise.duration > 0 && (
                    <DetailCol
                      paddingLeft={
                        exercise.weight > 0 || exercise.repetitions > 0
                      }
                      paddingRight={
                        !(exercise.weight > 0 || exercise.repetitions > 0)
                      }
                      mainText={`${exercise.duration}${exercise.both_sides ? "'' per lato" : "''"
                        }`}
                      secondaryText={"Isometria"}
                      my={true}
                    />
                  )}
                  {exercise.centimeters > 0 && (
                    <DetailCol
                      paddingLeft={true}
                      mainText={exercise.centimeters}
                      secondaryText={"Centimetri"}
                      my={true}
                    />
                  )}
                  {exercise.rest > 0 && (
                    <DetailCol
                      paddingLeft={true}
                      mainText={exercise.rest + "''"}
                      secondaryText={"Riposo"}
                      my={true}
                    />
                  )}
                </Row>
              </Col>
            </Row>
          </Container>
        </ContainerResponsive>
      )}
    </div>
  );
}
